const _excluded = ["render"],
  _excluded2 = ["closeMenu", "hover"],
  _excluded3 = ["children", "label"],
  _excluded4 = ["children", "overrideClassName"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { FocusableItem, Menu as InnerMenu, MenuDivider as InnerMenuDivider, MenuItem as InnerMenuItem, SubMenu as InnerSubMenu } from "@szhsin/react-menu";
import ChevronRight from "@bolteu/kalep-react-icons/dist/ChevronRight";
import { cx } from "../../helpers/utils/cx";
const SUBMENU_OFFSET_X = -8;
const menuClassName = _ref => {
  let {
    state
  } = _ref;
  return cx("list-none w-80 py-2 px-0 absolute z-50 bg-layer-floor-2 rounded-md shadow-lg select-none outline-none", state === "closed" && "hidden");
};
const menuItemClassName = _ref2 => {
  let {
    hover
  } = _ref2;
  return cx("px-4 py-3 flex gap-3 no-underline bolt-font-body-m-regular", "outline-none", hover && "bg-neutral-secondary cursor-pointer");
};
export function MenuDivider() {
  return /*#__PURE__*/React.createElement(InnerMenuDivider, {
    className: cx("h-px bg-neutral-secondary")
  });
}
export function MenuItem(_ref3) {
  let {
      render
    } = _ref3,
    rest = _objectWithoutProperties(_ref3, _excluded);
  if (render) {
    return /*#__PURE__*/React.createElement(FocusableItem, null, _ref4 => {
      let {
          closeMenu,
          hover
        } = _ref4,
        restRenderProps = _objectWithoutProperties(_ref4, _excluded2);
      return render(_objectSpread({
        hover,
        onClick: _ref5 => {
          let {
            detail
          } = _ref5;
          closeMenu(detail === 0 ? "Enter" : undefined);
        },
        className: cx("block px-4 py-3", hover && "bg-neutral-secondary")
      }, restRenderProps));
    });
  }
  return /*#__PURE__*/React.createElement(InnerMenuItem, {
    onClick: rest.onClick,
    className: menuItemClassName,
    value: rest.value,
    disabled: rest.disabled,
    href: rest.href,
    target: rest.target
  }, rest.renderStartSlot && /*#__PURE__*/React.createElement("div", {
    className: cx("shrink-0 flex items-center")
  }, rest.renderStartSlot(rest)), /*#__PURE__*/React.createElement("div", {
    className: cx("max-w-full", !rest.wrapText && "truncate")
  }, rest.renderLabel ? rest.renderLabel(rest) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx("bolt-font-body-m-regular text-primary", rest.disabled && "text-secondary", !rest.wrapText && "truncate")
  }, rest.label), rest.description && /*#__PURE__*/React.createElement("div", {
    className: cx("bolt-font-body-s-regular text-secondary", !rest.wrapText && "truncate")
  }, rest.description))), rest.renderEndSlot && /*#__PURE__*/React.createElement("div", {
    className: cx("ml-auto shrink-0 flex items-center")
  }, rest.renderEndSlot(rest)));
}
export function SubMenuLabel(_ref6) {
  let {
    label
  } = _ref6;
  return /*#__PURE__*/React.createElement("div", {
    className: cx("flex w-full justify-between items-center gap-2")
  }, /*#__PURE__*/React.createElement("div", {
    className: cx("truncate")
  }, label), /*#__PURE__*/React.createElement(ChevronRight, {
    size: "md",
    className: cx("shrink-0 rtl:rotate-180")
  }));
}
export function SubMenu(_ref7) {
  let {
      children,
      label
    } = _ref7,
    props = _objectWithoutProperties(_ref7, _excluded3);
  return /*#__PURE__*/React.createElement(InnerSubMenu, _extends({
    gap: SUBMENU_OFFSET_X,
    className: cx("relative"),
    itemProps: {
      className: cx("relative px-4 py-3 w-full cursor-pointer", "hover:bg-neutral-secondary focus:bg-neutral-secondary focus:outline-none")
    },
    menuClassName: menuClassName,
    label: /*#__PURE__*/React.createElement(SubMenuLabel, {
      label: label
    })
  }, props), children);
}
export function Menu(_ref8) {
  let {
      children,
      overrideClassName
    } = _ref8,
    props = _objectWithoutProperties(_ref8, _excluded4);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(InnerMenu, _extends({
    className: cx("relative")
  }, props, {
    // eslint-disable-next-line react/jsx-no-bind -- Passing className from props
    menuClassName: state => cx(menuClassName(state), overrideClassName)
  }), children));
}